const REQUIRED_PATHS = [
  "id",
  "name",
  "scene",
  "scene.backgroundImage",
  "scene.baseColor",
  "scene.radialGlow",
  "scene.overlayTint",
  "scene.vignette",
  "scene.parallaxStrength",
  "scene.particleType",
  "glass",
  "glass.bg",
  "glass.blur",
  "glass.border",
  "glass.radius",
  "glow",
  "glow.edgeColor",
  "glow.edgeStrength",
  "glow.heroBoost",
  "accent",
  "accent.primary",
  "accent.secondary",
  "numeric",
  "numeric.positive",
  "numeric.warning",
  "numeric.danger",
  "ai",
  "ai.orbStyle",
  "ai.orbGlow",
];

const PARTICLE_TYPES = new Set(["none", "embers", "electric", "poppies", "dust"]);
const ORB_STYLES = new Set(["t", "bot", "poppy"]);

function getNestedValue(obj, path) {
  return path.split(".").reduce((curr, key) => {
    if (curr === undefined || curr === null) return undefined;
    return curr[key];
  }, obj);
}

export function validateTheme(theme) {
  // Check required properties
  const missing = [];
  for (const path of REQUIRED_PATHS) {
    const val = getNestedValue(theme, path);
    if (val === undefined) {
      missing.push(path);
    }
  }
  if (missing.length > 0) {
    throw new Error(
      `Theme "${theme.id || "UNKNOWN"}" missing required properties: ${missing.join(", ")}`
    );
  }

  if (!PARTICLE_TYPES.has(theme.scene.particleType)) {
    throw new Error(
      `Theme "${theme.id}" has unsupported scene.particleType "${theme.scene.particleType}".`
    );
  }

  if (!ORB_STYLES.has(theme.ai.orbStyle)) {
    throw new Error(
      `Theme "${theme.id}" has unsupported ai.orbStyle "${theme.ai.orbStyle}".`
    );
  }

  if (typeof theme.scene.vignette !== "number" || theme.scene.vignette < 0 || theme.scene.vignette > 1) {
    throw new Error(`Theme "${theme.id}" scene.vignette must be a number in range 0..1.`);
  }

  if (
    typeof theme.scene.parallaxStrength !== "number" ||
    theme.scene.parallaxStrength < 0 ||
    theme.scene.parallaxStrength > 1
  ) {
    throw new Error(`Theme "${theme.id}" scene.parallaxStrength must be a number in range 0..1.`);
  }

  // Only local scene assets are allowed.
  if (theme.scene.backgroundImage != null) {
    if (typeof theme.scene.backgroundImage !== "string") {
      throw new Error(`Theme "${theme.id}" scene.backgroundImage must be string|null.`);
    }
    if (!theme.scene.backgroundImage.startsWith("/scenes/")) {
      throw new Error(
        `Theme "${theme.id}" scene.backgroundImage must use local /scenes/* assets only.`
      );
    }
    if (/^https?:\/\//i.test(theme.scene.backgroundImage)) {
      throw new Error(
        `Theme "${theme.id}" scene.backgroundImage cannot be an external URL.`
      );
    }
  }

  if ("logoCore" in (theme.scene || {})) {
    throw new Error(
      `Theme "${theme.id}" uses legacy scene.logoCore, which is not allowed in V3.`
    );
  }

  return theme;
}
